import React from "react"
import Navbar from "../../../../Common/Navbar"
import Footer from "../../../../Common/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import TsProjectViewComp from "./Component/TsProjectViewComp"


const TsProjectView =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <TsProjectViewComp />
        </div>
        <Footer />
        </>
    )
}

export default TsProjectView